var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetchRecords from './fetchRecords';
/** Fetch records by ids.
 * Side-effect free:
 * - Does not write to shared state */
export default function fetchRecordsByIds(entity, ids) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const fetchParams = {
            payload: {
                filter_conditions: [
                    // @ts-expect-error
                    { field: 'id', predicate: 'containedIn', value: ids }
                ]
            },
            justReturnDataDontWriteToState: true
        };
        const result = (_b = (_a = (yield fetchRecords(entity, fetchParams))) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
        return result;
    });
}
